import React from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

interface BallooningPagesProps {
    pageNumber: number | null;
    setPageNumber: (pageNumber: number) => void;
    ballooningPages: { page_number: number; thumbnail: string }[];
    hoveringSidebar: boolean;
}

const BallooningPages: React.FC<BallooningPagesProps> = ({
    pageNumber,
    setPageNumber,
    ballooningPages,
    hoveringSidebar,
}) => {
    return (
        <div
            style={{
                width: '100%',
                minWidth: 0,
                boxSizing: 'border-box',
                overflowY: 'auto',
                overflowX: 'hidden',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                padding: '4px 0',
                position: 'relative',
                zIndex: 10,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
            }}
        >
            <Text
                style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    marginBottom: '5px',
                    opacity: hoveringSidebar ? 1 : 0.5,
                    transition: 'opacity 0.3s ease-in-out',
                }}
            >
                Pages
            </Text>

            {ballooningPages.map((page) => (
                <Card
                    key={page.page_number}
                    hoverable
                    onClick={() => setPageNumber(page.page_number)}
                    style={{
                        width: '100%',
                        boxSizing: 'border-box',
                        cursor: 'pointer',
                        textAlign: 'center',
                        boxShadow: 'none',
                        border:
                            page.page_number === pageNumber
                                ? '2px solid #1677ff'
                                : '2px solid transparent',
                        borderRadius: '8px',
                    }}
                    bodyStyle={{ padding: '5px' }}
                >
                    <img
                        src={page.thumbnail}
                        alt={`Page ${page.page_number}`}
                        style={{
                            display: 'block',
                            width: '100%',
                            maxWidth: '100%',
                            height: 'auto',
                            maxHeight: '80px',
                            borderRadius: '4px',
                        }}
                    />
                    <div
                        style={{
                            fontSize: '12px',
                            fontWeight: 'bold',
                            marginTop: '5px',
                        }}
                    >
                        {page.page_number}
                    </div>
                </Card>
            ))}
        </div>
    );
};

export default BallooningPages;
